import { css } from '@emotion/react'

export default css`
    .ant-checkbox-wrapper span:not(.ant-checkbox) {
        font-size: 14px;
    }

    .ant-checkbox-wrapper span:not(.ant-checkbox) svg {
        font-size: 20px;
    }
`
